export interface ScrollKeeper {
    rememberPosition(): void;
    restorePosition(): void;
}

export type ScrollKeeperFactory = (selector: string) => ScrollKeeper;

(function () {
    angular.module('tradersyard').factory('scrollKeeper', scrollKeeperFactory);

    scrollKeeperFactory.$inject = ['$document'];

    /**
     * Keeps scroll position / viewport in place.
     *
     * When you add new items to the top of some scrollable list and your viewport/scroll position is all the way up,
     * the browser will "glue" the scroll position to the top, so that new items will appear.
     *
     * This is not ideal in some cases where we want to keep the viewport/scroll position after new items are loaded.
     * For e.g. in a chat window, where we want to load new messages on top,
     * but user viewport should stay on the currently displayed message.
     *
     */
    function scrollKeeperFactory($document: ng.IDocumentService): ScrollKeeperFactory {
        /**
         * @param {string} selector CSS selector of the viewport container.
         */
        return function createScrollKeeper(selector): ScrollKeeper {
            let lastPosition = 0;

            return {
                rememberPosition,
                restorePosition,
            };

            /**
             * Remember current position. Call this BEFORE new items are added.
             */
            function rememberPosition() {
                getEl((el: Element) => {
                    lastPosition = el.scrollHeight;
                });
            }

            /**
             * Restore position. Call this AFTER items are added.
             */
            function restorePosition() {
                window.requestAnimationFrame(() =>
                    getEl((el: Element) => {
                        return (el.scrollTop = el.scrollHeight - lastPosition);
                    })
                );
            }

            /**
             * Try to get viewport element and call callback on it if the element was found.
             *
             * @returns {HTMLElement|undefined}
             */
            function getEl(cb: any) {
                const el = $document.find(selector)[0];
                if (!el) return;
                console.log('KEEP-SCROLL ELEMENT FOUND', el);
                return cb && cb(el);
            }
        };
    }
})();
